import { ModelHelper } from '../classes/model-helper';

/**
 * Timezone model
 */
export class Timezone {
	id: string;
	displayName: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param Timezone
	 * @returns Timezone
	 */
	static map(data: any, timezone: Timezone = new Timezone()): Timezone {
		return timezone.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Timezone
	 */
	public map(data: any): Timezone {
		ModelHelper.map(data, this, 'id');
		ModelHelper.map(data, this, 'displayName');

		return this;
	}

	/**
	 * Prepare data for API
	 *
	 * @param data
	 */
	public getDataForApi(data: any = this): any {
		return { id: data.id };
	}
}
